<template>
  <div class="box9">
    <pageTitle
      title="大型真实项目实战<br/>深度练习企业测试场景"
      text="覆盖电商、新闻、智能物联网、人工智能、企业级服务等热门行业，使学员在学习的过程中如同浸泡在真实企业开发环境中"
      titleColor="#24375C"
      titColor="#86909C"
    />

    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          :class="{ 'cur-nav': cur == index }"
          v-for="(item, index) in projectList"
          :key="index"
          @click="changeCur(index)"
        >
          {{ item.name }}
        </div>
      </div>

      <div @click="showPop">
        <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in projectList"
            :key="index"
          >
            <div class="wrap">
              <img class="img" :src="item.img" alt="" />
              <div class="projectName">
                <p>{{ item.name }}</p>
              </div>

              <div class="projectDesc">{{ item.txt }}</div>
              <div class="btn">查看全部</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ projectList[this.cur].name }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="intro">{{ projectList[this.cur].txt }}</div>

        <div class="tag">项目亮点</div>
        <div class="target">
          <p
            class="indent"
            v-for="(i2, index2) in projectList[this.cur].lightPoint"
            :key="index2"
          >
            {{ i2 }}
          </p>
        </div>

        <div class="tag tag2">技术解决方案</div>
        <div class="target">
          <p
            v-for="(i3, index3) in projectList[this.cur].solution"
            :key="index3"
          >
            {{ i3 }}
          </p>
        </div>
      </div>
    </van-popup>
    <!-- <box9 /> -->
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,

      projectList: [
        {
          img: require("../../../assets/coursePage/softwareTest/box8/hmtt.png"),
          name: "黑马头条",
          txt: "这是一个综合性实战项目，模拟真实互联网新闻平台（如今日头条、腾讯新闻）的核心业务，涵盖内容创作、推荐分发、用户互动、数据统计等完整流程。",
          lightPoint: [
            "1. 覆盖从内容生产到消费的全链路。",
            "2. 涵盖禅道缺陷管理。",
            "3. 成熟的测试思路，采用项目推动教学。",
          ],
          solution: [
            "禅道缺陷管理",
            "AI测试用例生成",
            "抓包工具缺陷定位"
          ]
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box8/tpshop.png"), // 假设图片路径，需根据实际情况修改
          name: "TpShop商城",
          txt: "TpShop是一个完整的电子商务平台，涵盖了从商品展示、购物车管理、订单处理到支付和物流跟踪的全过程。这为学生提供了模拟真实商业环境的机会，让我们了解如何在一个复杂的电商系统中进行功能测试。",
          lightPoint: [
            "1. 功能丰富的电商系统项目实战，web端自动化测试。",
            "2. 成熟的测试思路，采用项目推动教学。"
          ],
          solution: [
            "seleium框架web端自动化测试",
          ],
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box8/anxiang.png"),
          name: "安享智慧理财",
          txt: "安享智慧理财金融系统是基于Java语言开发，集PC端、APP端、WAP端、微信端为一体的借贷系统，提供了完整的借款和投资功能。新版在各版本基础上，重新设计系统架构，增加新功能及简化流程，实现业务自定义等，让平台更具智能化，高安全性，快速响应，更有助于平台运营和发展。",
          lightPoint: [
            "1. 火热的金融类项目实战。",
            "2. 涵盖企业重要的功能测试和自动化测试。",
            "3. 模拟金融项目真实的全流程测试。",
            "4. 成熟的测试思维，通过“总-分-总”的方式，由浅入深，由单点到系统，在产品层面把控测试质量。",
            "5. 将测试知识体系与敏捷项目开发相结合，体验敏捷测试在实际项目中的运用。",
            "6. 对企业级的、复杂业务的金融项目提供了完整的自动化测试方案。",
            "7. 项目重点突出了企业级通用的接口测试流程。"
          ],
          solution: [
            "pytest+seleium框架web端自动化测试",
            "PO 模式封装自动化测试脚本",
            "jenkins+git 持续集成",
            "json数据驱动测试",
          ],
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box8/kedatianxia.png"), // 假设图片路径，需根据实际情况修改
          name: "客达天下",
          txt: "客达天下是传智教育推出的一款销售管理系统(CRM)，项目采用前后端分离技术、全面覆盖大厂主流的HTTP接口和dubbo接口技术；项目业务功能模块通用性强，主要包含：线索管理、合同管理、转派管理、权限管理。我们将使用postman、jmeter、python+request对客达天下进行接口测试，同时使用dubboclient进行dubbo接口测试。",
          lightPoint: [
            "1. 传智教育推出的一款销售管理系统(CRM)覆盖大厂主流的HTTP接口和dubbo接口技术。",
            "2. 使用postman、jmeter、python+request对客达天下进行接口测试。",
            "3. 使用dubboclient进行dubbo接口测试。",
          ],
          solution: [
            "request结合pytest框架接口测试；",
            "postman接口测试解决方案；",
            "jmeter接口测试解决方案；",
            "数据分离处理方法。",
          ],
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box8/hongmengmeikou.png"), // 假设图片路径，需根据实际情况修改
          name: "鸿蒙美蔻商城",
          txt: "鸿蒙美蔻商城项目是基于华为的鸿蒙操作系统（HarmonyOS）开发的一款电子商务应用，旨在为用户提供一个流畅、安全且功能丰富的购物体验。我们不仅对鸿蒙美蔻商城项目进行功能测试和专项测试，并且采用 Hypium自动化框架对纯血鸿蒙APP进行自动化测试。",
          lightPoint: [
            "1. 基于华为鸿蒙操作系统（HarmonyOS）开发的电商应用，专为万物互联时代设计。",
            "2. 涵盖鸿蒙的功能测试和专项测试。",
            "3. 使用DevEco_testing进行鸿蒙应用的专项测试。",
            "4. Hypium自动化框架对纯血鸿蒙APP进行自动化测试。",
          ],
          solution: [
            "SP_daemon鸿蒙性能测试监控；",
            "鸿蒙专项测试解决方案；",
            "鸿蒙自动化解决方案。",
          ],
        },
      ],
      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box5",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("nav-box")[0].scrollLeft =
              this.realIndex * 75;
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    showPop(){
      this.show = true
      this.mai("软件测试-就业课","查看全部",0,this.projectList[this.cur].name)
    },
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);

      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0px 0;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box8/bg.png")
    no-repeat;
  background-size: cover;
  overflow: hidden;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
  /deep/ .course-text {
    padding: 0 32px;
  }
  .van-popup {
    padding-bottom: 24px;
    max-height: calc(100% - 80px);
    box-sizing: border-box;
  }
  .titleContent {
    margin: 0 auto 60px;
    width: 360px;
    height: 80px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 4px 20px 0px rgba(202, 211, 235, 0.3),
      inset 2px 2px 2px 0px #ffffff;
    border-radius: 48px;
    backdrop-filter: blur(16px);
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    display: flex;
    padding: 0 8px 0 48px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    p {
      width: 176px;
      height: 64px;
      background: linear-gradient(270deg, #8192ff 0%, #a2aeff 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
    }
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .subject-box {
    position: relative;
    margin: 0px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;
      .wrap {
        overflow: hidden;
        margin: 32px 0 50px;
        padding: 4px 0 30px;
        box-sizing: border-box;
        background: linear-gradient( 135deg, #DDEDFF 0%, #FFFFFF 100%);
        border-radius: 20px;
      }
      .wrap::before {
        content: "";
        position: absolute;
        top: 32px;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 20px; /* 确保伪元素也有圆角 */
        padding: 4px; /* 模拟边框宽度 */
        background: linear-gradient(182deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box, 
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none; /* 避免伪元素影响鼠标事件 */
      }
      .img {
        width: 573px;
        object-fit: cover;
        border-radius: 16px;
        margin: 0 auto;
        display: block;
      }
      .projectName {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #4192ED;
        line-height: 40px;
        text-align: center;
        margin: 18px 0 24px;
        p {
          position: relative;
          width: fit-content;
          margin: 0 auto;
          &::before {
            content: "“";
            position: absolute;
            top: 12px;
            left: -70px;
            width: 20px;
            height: 18px;
            color: #E1EAFF;
            font-size: 50px;
          }
          &::after {
            content: "”";
            position: absolute;
            top: 12px;
            right: -40px;
            width: 20px;
            height: 18px;
            color: #E1EAFF;
            font-size: 50px;
          }
        }
      }
      .intro {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5d76ff;
        line-height: 48px;
        margin-bottom: 16px;
        text-align: justify;
        display: inline-block;
      }
      .projectDesc {
        padding: 0 42px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        background: linear-gradient(
          180deg,
          #86909c 0%,
          rgba(134, 144, 156, 0) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        height: 88px;
        overflow: hidden;
      }
      .btn {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;

        line-height: 56px;
        text-align: center;
        margin: 24px auto 0;

        width: 180px;
        height: 56px;
        background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
        border-radius: 32px;
      }
    }

    .nav-box {
      display: flex;
      justify-content: space-between;
      margin: 48px 0 0px;
      position: relative;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #1d2129;
      display: flex;
      justify-content: space-between;
      overflow-x: scroll;
      transition: all 0.2s;
      padding: 0 32px 0 32px;
      .nav {
        padding: 12px 24px;
        background: #ffffff;
        border-radius: 8px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 24px;
        color: #4E5969;
        line-height: 48px;
        text-align: center;
        margin-right: 20px;
        flex-shrink: 0;
      }

      .cur-nav {
        background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);

        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;

        position: relative;
      }
    }
  }

  .swiper-slide {
    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2674ff;
      line-height: 56px;
    }
    .tag2 {
      width: 220px;
    }
    .target {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
      p.indent {
        display: inline-block;
        text-align: justify;
        text-indent: -32px;
        padding-left: 40px;
      }
      // p.indent:nth-child(9) ~ p.indent {
      //   text-indent: -43px;
      //   padding-left: 43px;
      // }
    }
  }
}
</style>
